import {
  Component,
  inject,
  input,
} from '@angular/core'
import { ColDef, GetRowIdFunc } from 'ag-grid-community'
import { TableHeaderComponent } from '../table/headers/table-header.component'
import { ActionCellComponent } from '../table/cells/action-cell.component'
import { MDMASettlementsService } from '../settlements/mdma-settlements.service'
import { DataTableComponent } from '../table/data-table.component'

export type PublishedDetailsFile = Readonly<{
  fileName: string
  runInstanceUid: string
}>

@Component({
  selector: 'app-published-details-review-files',
  template: `
    <app-data-table
        style='height: 100%'
        heightStyle='100%'
        [data]="files()"
        [defaultColDef]="defaultColDef"
        [columnDefs]="columnDefs"
        [loading]="filesLoading()"
        [getRowId]="getRowId"
    />
  `,
  styles: `
    :host {
      display: block;
      height: 100%;
    }
  `,
  imports: [
    DataTableComponent,
  ],
})
export class PublishedDetailsReviewFilesComponent {
  private readonly settlementService = inject(MDMASettlementsService)

  readonly files = input.required<PublishedDetailsFile[]>()
  readonly filesLoading = input.required<boolean>()

  protected defaultColDef: ColDef = {
    editable: false,
    resizable: false,
    filter: false,
    sortable: false,
    suppressMovable: true,
    headerComponent: TableHeaderComponent,
    headerComponentParams: { filterGroup: 'n/a' },
  }

  protected columnDefs: ColDef[] = [
    {
      headerName: 'File',
      field: 'fileName',
      flex: 1,
    },
    {
      width: 75,
      pinned: 'right',
      cellRenderer: ActionCellComponent,
      cellRendererParams: {
        actions: [
          {
            name: 'Download',
            onAction: (d: PublishedDetailsFile) =>
              this.settlementService.downloadPublishedMDMAFile(d.runInstanceUid, d.fileName),
          },
        ],
      },
    },
  ]

  protected getRowId: GetRowIdFunc<PublishedDetailsFile> = p => p.data.fileName
}
